import { withLargeButtonAlignment } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import BpkLargeLocationIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/location';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import classNames from 'classnames';

import type { BlockQuoteProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/RichTextProps';

import STYLES from './BlockQuote.module.scss';

const BlockQuote = ({
  children,
  isConstrained = true,
  topTipTitle,
  variant,
}: BlockQuoteProps) => {
  const AlignedBpkLargeLocationIcon =
    withLargeButtonAlignment(BpkLargeLocationIcon);

  return topTipTitle ? (
    <div
      className={classNames(
        STYLES.BlockQuote,
        STYLES.BlockQuote__TopTip,
        isConstrained && STYLES['BlockQuote__TopTip--constrained'],
        STYLES[`BlockQuote__${variant}`],
      )}
    >
      <div className={STYLES['BlockQuote__TopTip-Title']}>
        <AlignedBpkLargeLocationIcon />
        <BpkText textStyle={TEXT_STYLES.heading3}>{topTipTitle}</BpkText>
      </div>
      {children}
    </div>
  ) : (
    <div
      className={classNames(
        STYLES.BlockQuote,
        STYLES[`BlockQuote__${variant}`],
      )}
    >
      {children}
    </div>
  );
};

export default BlockQuote;
